// @file This file contains exports that can be used in rails without
// importing dependecy on `tldraw`.
// When adding new exports, please ensure that file does not import any dependency on `tldraw`.
// Eg We should not import any files from `@@/bits/whiteboard` since it has a dependecy on `tldraw`.
import { isAppCapableOf } from '@@/bits/app_can'
import device from '@@/bits/device'

export const CANVAS_HEIGHT = 1080
export const CANVAS_WIDTH = 1920

export const AUDIO_PLAYER_DEFAULT_WIDTH = 260
export const AUDIO_PLAYER_DEFAULT_ASPECT_RATIO = 1

export const WHITEBOARD_ATTACHMENT_PADDING = 0

export function shouldEnableWhiteboardInPlaceUploadingAnimation(): boolean {
  return !device.app || isAppCapableOf('whiteboardInPlaceUploadingAnimation')
}
